export const EMPTY_STATE_BG_VARIANTS = {
  BIG_LIST: 'big-list',
  LIST: 'list',
  TABLE: 'table',
};
